import { Dialog } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type ModalHeaderProps = {
  title: string;
  classNames?: {
    wrapper?: string;
  };
  closeModal: VoidFunction;
};

export const ModalHeader: FC<ModalHeaderProps> = ({ title, closeModal, classNames }) => {
  const { t } = useTranslation();

  return (
    <div className={twMerge('px-4 sm:px-6', classNames?.wrapper)}>
      <div className='flex items-start justify-between'>
        <Dialog.Title className='text-lg font-medium text-gray-900'>{title}</Dialog.Title>
        <div className='ml-3 flex h-7 items-center'>
          <button
            type='button'
            className='rounded-md bg-white-100 text-gray-800 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-700'
            onClick={closeModal}
            disabled={false}
          >
            <span className='sr-only'>{t('sr_only:close_modal')}</span>
            <XIcon className='size-6' aria-hidden='true' />
          </button>
        </div>
      </div>
    </div>
  );
};
